// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.textarea-email.v-text-field--enclosed .v-input__append-inner {\n  align-self: end;\n  padding: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
